var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    staticClass: "payment-connect",
    attrs: {
      title: "关联打款信息",
      width: "360px",
      visible: _vm.visible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      },
      close: _vm.close
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      "label-position": "right",
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "金额"
    }
  }, [_c("span", [_vm._v(" ¥ " + _vm._s(_vm.formatThousands(_vm.form.receiptAmount)))])]), _c("el-form-item", {
    attrs: {
      label: "打款方"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.form.payer))])]), _c("el-form-item", {
    attrs: {
      label: "收款方"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.form.payeeCompany) + " ")]), _c("SourceTag", {
    attrs: {
      type: _vm.form.dataSource
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "合同",
      prop: "contractCode"
    }
  }, [_vm.form.contractCode ? _c("div", {
    staticClass: "contract-info"
  }, [_c("div", {
    staticClass: "contractNbr"
  }, [_c("span", [_vm._v(_vm._s(_vm.form.contractCode))]), _c("aside", {
    on: {
      click: _vm.relate
    }
  }, [_vm._v("更换")])]), _c("span", [_vm._v("订单分账：¥ " + _vm._s(_vm.formatThousands(_vm.form.orderAmount)))]), _vm._v(" / "), _c("span", [_vm._v("押金分账：¥ " + _vm._s(_vm.formatThousands(_vm.form.depositAmount)))])]) : _c("div", {
    staticClass: "add-contract",
    on: {
      click: _vm.relate
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])]), _c("el-form-item", {
    attrs: {
      label: "公司",
      prop: "companyId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      size: "small",
      filterable: "",
      remote: "",
      "reserve-keyword": "",
      placeholder: "请输入关键词",
      "remote-method": _vm.remoteMethod,
      loading: _vm.companyLoading
    },
    model: {
      value: _vm.form.companyId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "companyId", $$v);
      },
      expression: "form.companyId"
    }
  }, _vm._l(_vm.companyList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.companyName,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "回单",
      prop: "slip"
    }
  }, [_vm.isAli ? _c("wlc-upload-image", {
    attrs: {
      url: _vm.form.slip
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "slip", $event);
      }
    }
  }) : _vm.form.slip ? _c("el-link", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.previewPdf(_vm.form.slip);
      }
    }
  }, [_vm._v("查看回单")]) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)], 1), _c("RelatedContract", {
    ref: "relatedContract",
    on: {
      save: _vm.selectContract
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };